import { render, staticRenderFns } from "./InstallStatistical.vue?vue&type=template&id=41e3bd8e&scoped=true&"
import script from "./InstallStatistical.vue?vue&type=script&lang=js&"
export * from "./InstallStatistical.vue?vue&type=script&lang=js&"
import style0 from "./InstallStatistical.vue?vue&type=style&index=0&id=41e3bd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e3bd8e",
  null
  
)

export default component.exports